// extracted by mini-css-extract-plugin
module.exports = {"luckyturntable":"components_luckyturntable__rRFX5"};